import NextLink from 'next/link'
import dayjs from 'dayjs'
import Card from '@audioeye-marketing/ui/src/components/Card'
import Stack from '@audioeye-marketing/ui/src/components/Stack'
import Typography from '@audioeye-marketing/ui/src/components/Typography'
import Chip from '@audioeye-marketing/ui/src/components/Chip'
import colors from '@audioeye-marketing/ui/src/theme/colors'
import Edit04 from '@audioeye/ui-icons/Line/General/Edit04'
import ImageIndentLeft from '@audioeye/ui-icons/Line/Editor/ImageIndentLeft'
import Animate from '@/components/misc/Animate'
import Image from '@/components/storyblok/items/Image'

const FeaturedArticle = ({ data, size }) => {
  const image =
    size !== 'sm' && data?.content?.social_banner?.filename
      ? data?.content?.social_banner
      : size !== 'sm' && data?.content?.component === 'Press'
        ? {
            alt: 'Read the latest press release from AudioEye, Inc.',
            filename:
              'https://a-us.storyblok.com/f/1015620/4800x2521/d7a903acbe/audioeye_press-release_social-banner_default.jpg',
          }
        : null

  return (
    <Animate fadeY>
      <Card
        component={NextLink}
        href={`/${data.full_slug}/`}
        className={`featured-article featured-article-${size}`}
        noBorderRadius
        variant="plain"
        sx={{
          width: '100%',
          gap: '0',
          // For focus state
          height: 'calc(100% - 3px)',
          textDecoration: 'none',
          padding: 0,
          transition: 'background-color 125ms ease-in-out',
          '&:hover': {
            cursor: 'pointer',
          },
          '&:focus': {
            outline: `2px solid ${colors.primary[500]} !important`,
            borderRadius: '2px',
          },
        }}
      >
        {Boolean(image) && <Image blok={{ image }} aspectRatio="1200/630" />}
        <Stack direction="column" spacing={1} sx={{ padding: 3 }}>
          <Stack direction="row" spacing={1} alignItems="center">
            {Boolean(data?.content?.component === 'Post') && (
              <Chip color="primary" startDecorator={<Edit04 />}>
                Blog
              </Chip>
            )}
            {Boolean(data?.content?.component === 'Press') && (
              <Chip color="primary" startDecorator={<ImageIndentLeft />}>
                Press
              </Chip>
            )}
            <Typography level="body-sm">
              {dayjs(
                data?.content?.component === 'Press' ? data.content.published_date : data.content.last_updated_date,
                'YYYY-MM-DD HH:mm'
              ).format('MM/DD/YYYY')}
            </Typography>
          </Stack>
          <Typography level="title-lg">{data.content.title}</Typography>
          {size === 'lg' && <Typography>{data.content.summary}</Typography>}
        </Stack>
      </Card>
    </Animate>
  )
}

export default FeaturedArticle
